import { Link } from "react-router-dom";
import styled from "styled-components";
import { linkPills } from "../../style/styled-components/mixins";
import TitleTemplate from "../../components/ui/common/template/TitleTemplate";
import PageTemplate from "../../components/ui/common/template/PageTemplate";
import WorkScopes from "../../components/ui/specialty/WorkScopes";
import DiamondScope from "../../components/ui/specialty/DiamondScope";
import PlatformLink from "../../components/ui/specialty/PlatformLink";
import ContactPoints from "../../components/ui/members/ContactPoints";
import CompareTable from "../../components/ui/specialty/CompareTable";
import CenterDiv from "../../style/styled-components/components/CenterDiv";
import DiagnosisImage from "../../resources/images/diagnosis.jpg";
import imgCompliance from "../../resources/images/a1tcms/05-compliance.png";
import imgAudit from "../../resources/images/a1tcms/03-audit-risk.png";
import icon1 from "../../resources/images/icon/10. 기업진단/3. 관세평가 적정성 진단.png";
import icon2 from "../../resources/images/icon/10. 기업진단/2. 품목분류 적정성  일관성 진단.png";
import icon3 from "../../resources/images/icon/3. 환급/1. 관세환급 진단 컨설팅, 소요량 사전심사 컨설팅.png";
import icon4 from "../../resources/images/icon/10. 기업진단/4. 외환거래 적법성 진단.png";
import icon5 from "../../resources/images/icon/4. 요건/3. 업체별 인증품목 관리.png";
import icon6 from "../../resources/images/icon/8. AEO/3. AEO 정기자체평가 관리.png";

// 근거: ASCP 시스템 체계 정의서 v1 (ACRIS 심사 리스크 진단·외환 컴플라이언스, ASALES AEO 관리), https://a1tcms.com
const CompliancePage = () => {
  return (
    <PageTemplate
      large
      image={DiagnosisImage}
      title="지능형 컴플라이언스"
      phrase="세관 조사 전에, 스스로 점검하고 미리 바로잡습니다."
    >
      <p>
        수입·수출신고와 외환 거래 자료를 상시 점검해 지적 가능성을 먼저 찾아냅니다.
        사람이 며칠 걸려 대사하던 자료를 ASCP가 부문별로 나눠 짚고, 세관 심사 경험이 많은 관세사가 결과를 판단합니다.
      </p>

      <TitleTemplate
        title="점검 6개 부문"
        noImage
        subHeader="신고 데이터의 정합성과 이상징후를 부문별로 점검합니다."
      />
      <WorkScopes
        contents={[
          { title: "과세가격 (운임·보험료·가산요소·특수관계)", icon: icon1 },
          { title: "품목분류 (동일 물품 세번 일관성)", icon: icon2 },
          { title: "환급 (미신청 환급 기회 발굴)", icon: icon3 },
          { title: "외환 (신고금액 ↔ 송금 대사)", icon: icon4 },
          { title: "수출입요건 (요건 확인 누락)", icon: icon5 },
          { title: "감면·분납 (감면·면세코드 적정성)", icon: icon6 },
        ]}
      />

      <TitleTemplate
        title="ASCP 연계"
        noImage
        subHeader="자료를 올리면 진단보고서가 나옵니다."
      />
      <PlatformLink
        system="ACRIS"
        module="심사 리스크 진단"
        text="수입신고·수출신고·외환거래 자료를 업로드하면 6개 부문을 자동 점검해 부문별 지적사항·근거 데이터·개선 방향을 담은 진단보고서(Word·PDF·Excel)를 만듭니다."
        image={imgAudit}
      />
      <br />
      <PlatformLink
        system="ACRIS"
        module="지능형 컴플라이언스"
        text="신고 정합성을 상시 모니터링하고, 환급 기회를 자동으로 찾으며, EU 탄소국경조정제도(CBAM)에 대응합니다."
        image={imgCompliance}
      />

      <TitleTemplate
        title="이렇게 달라집니다"
        noImage
        subHeader="사후 대응에서 사전 예방으로."
      />
      <CenterDiv>
        <CompareTable
          contents={[
            { div: "점검 시점", content1: "세관 조사 통지 후", content2: "상시 또는 정기 점검" },
            { div: "대사 방식", content1: "담당자가 표를 뒤지며 수작업", content2: "업로드 한 번으로 부문별 자동 점검" },
            { div: "결과물", content1: "메모·내부 공유", content2: "근거 데이터를 갖춘 진단보고서" },
            { div: "후속 조치", content1: "개별 대응", content2: "수정신고·경정청구·환급까지 통합 관리" },
          ]}
        />
      </CenterDiv>

      <TitleTemplate
        title="Strength"
        noImage
        subHeader="진단부터 수출입통관까지 함께할 수 있는 에이원만의 서비스입니다."
      />
      <DiamondScope
        contents={[
          { title: "심사 경험", text: "세관 출신 전문가와 심사 전문 관세사의 판단" },
          { title: "자동 점검", text: "6개 부문 정합성·이상징후 자동 분석" },
          { title: "데이터 보안", text: "고객사 서버 안에서만 처리, 외부 반출 없음" },
          { title: "통합 관리", text: "수정신고·경정청구·환급까지 이어서 처리" },
        ]}
      />
      <Links>
        <Link to="/consulting/diagnosis">기업진단 컨설팅 →</Link>
        <Link to="/legal/customs">관세심사 대응 →</Link>
      </Links>

      <TitleTemplate
        title="Contact Point"
        noImage
        subHeader="언제나 믿고 맡길 수 있는 최고의 멤버와 함께합니다."
      />
      <ContactPoints members={["son0077", "cupark"]} />
    </PageTemplate>
  );
};
export default CompliancePage;

const Links = styled.div`
  ${linkPills}
  padding-top: 2rem;
`;
